import React, { useState, useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { UseProduct } from "./UseProduct";
import CategoryAutoComplete from "../../basic-information/productCategory/CategoryAutoComplete";
import BrandAutoComplete from "../../basic-information/brand/BrandAutoComplete";
import CompanyAutoComplete from "../../basic-information/company/CompanyAutoComplete";
import CountryAutocomplete from "../../basic-information/Countries/CountryAutocomplete";
import LicenceAutocomplete from "../../basic-information/Countries/LicenceAutocomplete";
import { useSnackbar } from "notistack";
import SearchCom from "./SearchCom";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel1(props) {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl1Edit } = UseProduct();
  const [stateValidation, setStateValidation] = useState({
    faName: false,
    enName: false,
    brandID: false,
    categoryID: false,
    countryID: false,
    companyID: false,
  });
  const { isSmall } = useBreakpoints();

  const [level1, setLevel1] = React.useState({
    id: props.product.id,
    faName: props.product.faName,
    enName: props.product.enName,
    brandID: props.product.brandID,
    categoryID: props.product.categoryID,
    countryID: props.product.countryID,
    licenceCountryID: props.product.licenceCountryID,
    companyID: props.product.companyID,
  });

  useEffect(() => {
    if (props.fire) {
      validateStep();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel1"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        sx={{ mb: 0 }}
        onClick={() => props.setExpanded("panel1")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>
          مرحله اول : اطلاعات پایه
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <SearchCom
              state={level1}
              setState={setLevel1}
              stateValidation={stateValidation.faName}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              size="small"
              id="outlined-basic"
              value={level1.enName ? level1.enName : ""}
              error={stateValidation.enName}
              label="نام لاتین "
              variant="outlined"
              onChange={(event) => {
                setLevel1({
                  ...level1,
                  enName: event.target.value,
                });
              }}
              sx={{ width: "100%", input: { direction: "rtl" } }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <CategoryAutoComplete
              selectedCategoryID={level1.categoryID}
              validation={stateValidation.categoryID}
              setter={setLevel1}
              lvl1State={level1}
            ></CategoryAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <BrandAutoComplete
              selectedBrandID={level1.brandID}
              validation={stateValidation.brandID}
              setter={setLevel1}
              lvl1State={level1}
            ></BrandAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <CompanyAutoComplete
              selectedCompanyID={level1.companyID}
              validation={stateValidation.companyID}
              setter={setLevel1}
              lvl1State={level1}
            ></CompanyAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <CountryAutocomplete
              selectedCountryID={level1.countryID}
              validation={stateValidation.countryID}
              setter={setLevel1}
              lvl1State={level1}
            ></CountryAutocomplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <LicenceAutocomplete
              selectedLicenceID={level1.licenceCountryID}
              setter={setLevel1}
              lvl1State={level1}
            ></LicenceAutocomplete>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => validateStep()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function validateStep() {
    validateLvl1Edit(
      level1,
      setStateValidation,
      (res) => {
        if (props.fire == false) {
          enqueueSnackbar("مرحله اول با موفقیت تکمیل شد", {
            variant: "success",
            autoHideDuration: 2000,
          });
          props.setExpanded("panel2");
        }
        props.fill(level1);
      },
      props.setFire
    );
  }
}
